angular.module('unica_social_stream.social_stream_services')

.factory('SocialStreamListService', function ($http, getBaseApiURL) {

	var socialStreamListService = {};

	socialStreamListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/social-stream/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.posts;
			}

		});

	};

	return socialStreamListService;
});